export default "__VITE_PUBLIC_ASSET__4d8c18d2__"